import {
    Component,
    ElementRef,
    ViewEncapsulation,
    inject,
    ChangeDetectionStrategy,
    OnInit,
} from '@angular/core';

const sharedStylesheet = new CSSStyleSheet();
sharedStylesheet.replaceSync(
    `:host { --size-sign: 56px; --size-icon: 21px; --border-width: 2px; --border-style: solid; --icon-padding: 7px; position: relative; display: block; width: var(--size-sign); height: var(--size-sign); } :host::before { content: ""; position: absolute; border-radius: 50%; width: var(--size-sign); height: var(--size-sign); background: rgba(var(--bazis-color-info-rgb), 0.2); } :host ::slotted(bazis-icon[slot=icon]) { position: absolute; top: 0; left: 0; right: 0; bottom: 0; width: var(--size-icon); height: var(--size-icon); margin: auto; border-radius: 50%; border: var(--border-width) var(--border-style) var(--bazis-color-white); padding: var(--icon-padding); background-color: var(--bazis-color-info); font-size: var(--size-icon); color: var(--bazis-color-white); } :host(.bazis-color)::before { background: rgba(var(--bazis-color-base-rgb), 0.2); } :host(.bazis-color) ::slotted(bazis-icon[slot=icon]) { background: var(--bazis-color-base); } :host(.bazis-color.bazis-color-light)::before { background: rgba(var(--bazis-color-white-rgb), 0.2); } :host(.bazis-color.bazis-color-light) ::slotted(bazis-icon[slot=icon]) { background: var(--bazis-color-white); color: var(--bazis-color-action); }`,
);

@Component({
    selector: 'bazis-sign-status',
    template: `
        <slot name="icon"></slot>
        <slot name="loader"></slot>
    `,
    // styleUrls: ['sign-status.component.scss'],
    encapsulation: ViewEncapsulation.ShadowDom,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class SignStatusElement implements OnInit {
    public el = inject(ElementRef);

    ngOnInit(): void {
        const host = this.el.nativeElement;
        if (host && host.shadowRoot) {
            const shadowRoot = host.shadowRoot;
            const styles = shadowRoot.querySelectorAll('style');
            styles.forEach((style) => style.remove());
            shadowRoot.adoptedStyleSheets = [sharedStylesheet];
        }
    }
}
